/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetReorderableOrderQueryVariables = Exact<{
  orderReferenceId: string;
}>;


export type GetReorderableOrderQuery = { getReorderableOrder: { priceUpdatedPackagings: Array<string>, unavailablePackagings: Array<string>, contractReferenceId: string, availablePackagings: Array<{ id: string, quantity: number, weight: number | null }> } | null };


export const GetReorderableOrderDocument = /*#__PURE__*/ gql`
    query getReorderableOrder($orderReferenceId: uuid!) {
  getReorderableOrder(orderReferenceId: $orderReferenceId) {
    availablePackagings {
      id
      quantity
      weight
    }
    priceUpdatedPackagings
    unavailablePackagings
    contractReferenceId
  }
}
    `;

/**
 * __useGetReorderableOrderQuery__
 *
 * To run a query within a React component, call `useGetReorderableOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReorderableOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReorderableOrderQuery({
 *   variables: {
 *      orderReferenceId: // value for 'orderReferenceId'
 *   },
 * });
 */
export function useGetReorderableOrderQuery(baseOptions: Apollo.QueryHookOptions<GetReorderableOrderQuery, GetReorderableOrderQueryVariables> & ({ variables: GetReorderableOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReorderableOrderQuery, GetReorderableOrderQueryVariables>(GetReorderableOrderDocument, options);
      }
export function useGetReorderableOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReorderableOrderQuery, GetReorderableOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReorderableOrderQuery, GetReorderableOrderQueryVariables>(GetReorderableOrderDocument, options);
        }
// @ts-ignore
export function useGetReorderableOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReorderableOrderQuery, GetReorderableOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetReorderableOrderQuery, GetReorderableOrderQueryVariables>;
export function useGetReorderableOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReorderableOrderQuery, GetReorderableOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetReorderableOrderQuery | undefined, GetReorderableOrderQueryVariables>;
export function useGetReorderableOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReorderableOrderQuery, GetReorderableOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReorderableOrderQuery, GetReorderableOrderQueryVariables>(GetReorderableOrderDocument, options);
        }
export type GetReorderableOrderQueryHookResult = ReturnType<typeof useGetReorderableOrderQuery>;
export type GetReorderableOrderLazyQueryHookResult = ReturnType<typeof useGetReorderableOrderLazyQuery>;
export type GetReorderableOrderSuspenseQueryHookResult = ReturnType<typeof useGetReorderableOrderSuspenseQuery>;
export type GetReorderableOrderQueryResult = Apollo.QueryResult<GetReorderableOrderQuery, GetReorderableOrderQueryVariables>;